// The pipeline's square tube on its bent path, lit from one side.
export default {
	name: 'cube_tunnel',
	label: 'Cube Tunnel',
	description: 'Flight down a winding square tunnel',

	expose: {
		speed: {
			tip: 'Flight speed; negative flies backwards',
			step: 0.05,
			period: 22.5,
			initial: 1,
			minimum: -8,
			maximum: 8,
		},
		wobble_view: {
			tip: 'Rolls the view from side to side',
			initial: 0,
		},
		wobble_rate: {
			tip: 'How fast the view rolls',
			step: 0.01,
			period: 66.7,
		},
		zoom: {
			tip: 'Narrows the field of view',
			minimum: 0.7,
			maximum: 3,
		},
		bend: {
			tip: 'How strongly the tunnel curves',
			initial: 1,
		},
		bend_angle: {
			tip: 'Which way the tunnel curves, round the view',
			initial: 0,
		},
		wander: {
			tip: 'Swings the curve from side to side down the tunnel; 0 curves one way forever',
			initial: 0,
		},
		bend_roll: {
			tip: 'Turns the way the tunnel curves as it goes',
			initial: 0.3,
		},
		light: {
			tip: 'Shading of the walls; 0 is flat',
			initial: 1,
		},
		light_angle: {
			tip: 'Where the light comes from, round the tunnel',
			initial: 0,
		},
		fog: {
			tip: 'How soon the tunnel fades into the ground',
			initial: 0.3,
			maximum: 1,
			step: 0.01,
		},
		color: {
			tip: 'First wall palette colour',
			initial: '#ff2fa8',
		},
		color_b: {
			label: 'Color 2',
			tip: 'Last wall palette colour',
			initial: '#1fe0c0',
		},
		spread: {
			tip: 'Number of colours from Color to Color 2',
			initial: 2,
		},
		repeat: {
			tip: 'Ramp restarts the palette, Mirror walks back',
			initial: 1,
		},
		wash: {
			tip: 'Scrolls the palette down the tunnel, colours per second',
			initial: 0,
			period: 1,
		},
		ground: {
			tip: 'Fog colour, and behind the walls: its colour and opacity',
			initial: '#000000',
		},
	},

	lock: {
		enclose: 1,
		tunnel: 1,
		rounding: 0,
		fit: 0,
		radius: 4,
		width: 100,
		spacing: 0,
		twist: 1,
		perspective: 2,
	},
	range: {
		rounding: [0, 1],
		tunnel: [0, 1],
		width: [0.1, 100],
		spacing: [0, 100],
		pan: [-1000, 1000],
		perspective: [1, 2],
	},
}
